import * as React from "react";
import { Box, CPHrBreak, CPText } from "shared/components/base";
import CPModal from "shared/components/shared/CPModal/CPModal";

interface CPResourceSecurityHelpModalProps {
  open: boolean;
  onClose: () => void;
}

const CPResourceSecurityHelpModal: React.FC<
  CPResourceSecurityHelpModalProps
> = ({ open, onClose }) => {
  return (
    <CPModal
      title="Visibility & Security"
      open={open}
      onClose={onClose}
      width={560}
    >
      <Box flexDirection="column" spacing={14}>
        <CPText>
          Resource visibility is controlled by two optional settings — Tier and
          Role. Only configure what you need; each one narrows who can see the
          resource.
        </CPText>

        {/* Decision matrix */}
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: 13,
          }}
        >
          <thead>
            <tr style={{ background: "#f0f4f8" }}>
              <th
                style={{
                  padding: "6px 10px",
                  border: "1px solid #dee2e6",
                  textAlign: "left",
                  fontWeight: 600,
                }}
              >
                Tier set?
              </th>
              <th
                style={{
                  padding: "6px 10px",
                  border: "1px solid #dee2e6",
                  textAlign: "left",
                  fontWeight: 600,
                }}
              >
                Role set?
              </th>
              <th
                style={{
                  padding: "6px 10px",
                  border: "1px solid #dee2e6",
                  textAlign: "left",
                  fontWeight: 600,
                }}
              >
                Who can view
              </th>
            </tr>
          </thead>
          <tbody>
            {[
              ["No", "No", "Anyone"],
              ["Yes", "No", "Users in agencies with the matching tier"],
              ["No", "Yes", "Users assigned the specified role"],
              ["Yes", "Yes", "Users assigned the role only — tier is ignored"],
            ].map(([tier, role, who], i) => (
              <tr
                key={i}
                style={{ background: i % 2 === 0 ? "#fff" : "#fafafa" }}
              >
                <td
                  style={{ padding: "5px 10px", border: "1px solid #dee2e6" }}
                >
                  {tier}
                </td>
                <td
                  style={{ padding: "5px 10px", border: "1px solid #dee2e6" }}
                >
                  {role}
                </td>
                <td
                  style={{ padding: "5px 10px", border: "1px solid #dee2e6" }}
                >
                  {who}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <Box
          style={{
            background: "#fff8e1",
            border: "1px solid #ffe082",
            borderRadius: 4,
            padding: "10px 12px",
          }}
          flexDirection="column"
          spacing={4}
        >
          <CPText bold fontSize="13px">
            Role takes priority when both are set
          </CPText>
          <CPText textStyle="caption" style={{ color: "#555" }}>
            When a resource has a role assigned, access is determined by the
            role alone — the tier setting is ignored. For example, if 10 agency
            users match a resource's tier but only 2 of those users hold the
            required role, only those 2 users will be able to see the resource.
          </CPText>
        </Box>

        <CPHrBreak />

        <CPText bold fontSize="13px">
          Category Visibility
        </CPText>
        <CPText textStyle="caption" style={{ color: "#555" }}>
          Categories have no security of their own. A category is visible to a
          user only when they have access to at least one resource within it. If
          a user loses access to all resources in a category, that category is
          automatically hidden for them.
        </CPText>
      </Box>
    </CPModal>
  );
};

export default CPResourceSecurityHelpModal;
